import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {PreparationResourceTypeSingleSelectEditControlComponent} from "./preparation-resource-type/controls/preparation-resource-type-single-select-edit-control.component";
import {OrderTypeMultiSelectEditControlComponent} from "./order-type/controls/order-type-multi-select-edit-control.component";
import {OrderProcessorMultiSelectSearchControlComponent} from "./order_processor/controls/order-processor-multi-select-search-control.component";
import {OrderTypeMultiSelectColumnComponent} from "./order-type/controls/order-type-multi-select-column.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
        PreparationResourceTypeSingleSelectEditControlComponent,
        OrderTypeMultiSelectEditControlComponent,
        OrderTypeMultiSelectColumnComponent,
        OrderProcessorMultiSelectSearchControlComponent
    ],
    exports: [
        PreparationResourceTypeSingleSelectEditControlComponent,
        OrderTypeMultiSelectEditControlComponent,
        OrderTypeMultiSelectColumnComponent,
        OrderProcessorMultiSelectSearchControlComponent
    ]
})
export class OrderProcessingSharedModule {
}
